import React from 'react';
import { Dialog, DialogTitle,DialogContent,DialogContentText,DialogActions,Button} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/reducers';


const StepThreePricerDialog = ({isConfirmOpen,handleCloseConfirmDialog,handleDialogConfirmation}) => {
    const selectedItems: any = useSelector<RootState>(
            (state) => state?.pagesV2['pricer-config-contracts-landing']?.selected
        );
    return (
        <Dialog open={isConfirmOpen} onClose={handleCloseConfirmDialog}>
                <DialogTitle>
                    Pricer
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {selectedItems.length === 0
                            ? <p className='text-danger'>Please select atleast one contract for process</p>
                            : 'Are you sure to process negotiated rates from latest contracts?'
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmDialog}>
                        Cancel
                    </Button>
                    <Button
                        onClick={()=>handleDialogConfirmation(selectedItems)}
                        disabled={selectedItems.length === 0}
                        color="primary">
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
    );
}

export default StepThreePricerDialog;
